import { useEffect, useState } from 'react';

const relativeTime = new Intl.RelativeTimeFormat(undefined, { numeric: 'always' });

function errorAge(occurredAtMs: number, now: number): string {
  const seconds = Math.max(0, Math.floor((now - occurredAtMs) / 1000));
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return relativeTime.format(-Math.floor(seconds / 60), 'minute');
  if (seconds < 86400) return relativeTime.format(-Math.floor(seconds / 3600), 'hour');
  return relativeTime.format(-Math.floor(seconds / 86400), 'day');
}

export function ClioSyncError({ occurredAtMs }: { occurredAtMs: number }) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 60_000);
    return () => window.clearInterval(timer);
  }, []);
  const occurredAt = new Date(occurredAtMs);
  return <p role="alert" className="rounded border border-amber-300 bg-amber-50 p-4">
    Clio sync failed <time dateTime={occurredAt.toISOString()} title={occurredAt.toLocaleString()}>
      {errorAge(occurredAtMs, now)}
    </time>. The Clio Matter could not be updated. Witness shows the current ceremony below.
  </p>;
}
